import { useEffect, useState } from "react";
import { useDocument } from "react-firebase-hooks/firestore";
import { db } from "@poseidon/firebase/firebase";

import { doc } from "firebase/firestore";

export const useBaseRate = () => {
  const [baseRate, setBaseRate] = useState();
  const [value, loading, error] = useDocument(doc(db, "baseRate/singleton"));
  useEffect(() => {
    setBaseRate(value?.get("baseRate"));
  }, [value]);

  return { baseRate, loading, error };
};
